import { startOfToday, endOfToday, startOfWeek, endOfWeek, isWithinInterval, isThisWeek, isToday, isThisMonth, formatRelative } from 'date-fns'
import * as chrono from 'chrono-node'
import { actionTypes } from './shit-action-types'

export const isShitDone = (shit) => {
  return 'completedAt' in shit && shit.completedAt !== null
}

export const isShitDoneToday = (shit) => {
  if (!shit.completedAt) {
    return false
  }

  return isWithinInterval(
    new Date(shit.completedAt),
    { start: startOfToday(), end: endOfToday() }
  )
}

export const isShitDoneThisWeek = (shit) => {
  if (!shit.completedAt) {
    return
  }

  const now = new Date()
  return isWithinInterval(
    new Date(shit.completedAt),
    { start: startOfWeek(now), end: endOfWeek(now) }
  )
}

export const doShitRepeats = (shit) => {
  return 'scheduledAt' in shit && shit.scheduledAt && 'repeat' in shit.scheduledAt
}

export const isShitScheduledToday = (shit) => {
  return shit.scheduledAt && isToday(new Date(shit.scheduledAt.start))
}

export const isShitScheduledThisWeek = (shit) => {
  return shit.scheduledAt && isThisWeek(new Date(shit.scheduledAt.start))
}

export const isShitScheduledThisMonth = (shit) => {
  return shit.scheduledAt && isThisMonth(new Date(shit.scheduledAt.start))
}

export const parseShitMetas = (description) => {
  const updates = {}

  const projectsRe = /(?<=#)\S+/g
  const projects = description.match(projectsRe) || []
  if (projects.length) {
    updates.projects = projects
  }

  const contextRe = /(?<=@)\S+/g
  const contexts = description.match(contextRe) || []
  if (contexts.length) {
    updates.contexts = contexts
  }

  const mentionsRe = /(?<=\+)\S+/g
  const mentions = description.match(mentionsRe) || []
  if (mentions.length) {
    updates.mentions = mentions
  }

  const repeatRe = /(?<=\*)\S+/g
  const repeat = (description.match(repeatRe) || []).pop()

  let scheduledAt = parseShitSchedule(description)
  if (repeat && !scheduledAt) {
    scheduledAt = getTodaySchedule()
  }

  if (scheduledAt) {
    updates.scheduledAt = scheduledAt
    updates.action = actionTypes.ACTION_SCHEDULE
    if (repeat) {
      updates.scheduledAt.repeat = repeat
    }
  } else {
    // remove this instead?
    updates.scheduledAt = null
  }

  // const priorityRe = /(?<=!)(\S+)/g
  // const priority = (description.match(priorityRe) || []).pop()
  // updates.priority = priority

  const actionRe = /(?<=\/)(\S+)/g
  const action = (description.match(actionRe) || []).pop()
  if (action && Object.values(actionTypes).includes(action)) {
    updates.action = action
  }
  console.warn(updates)

  return updates
}

export const getAllShitMetas = (shit) => {
  let values = []

  if (shit.projects.length) {
    values = values.concat(shit.projects.map(p => `#${p}`))
  }

  if (shit.contexts.length) {
    values = values.concat(shit.contexts.map(c => `@${c}`))
  }

  if (shit.mentions && shit.mentions.length) {
    values = values.concat(shit.mentions.map(c => `+${c}`))
  }

  if (shit.scheduledAt) {
    // console.warn(formatRelative(new Date(shit.scheduledAt.start), new Date()))
    values = values.concat([formatRelative(new Date(shit.scheduledAt.start), new Date())])

    if (shit.scheduledAt.repeat) {
      values = values.concat([`*${shit.scheduledAt.repeat}`])
    }
  }

  if (shit.action) {
    values = values.concat([`/${shit.action}`])
  }

  return values
}

export const parseShitSchedule = (text) => {
  const results = chrono.parse(text)
  if (!results.length) {
    return null
  }

  const parse = results[0]
  const schedule = {}
  schedule.parse = {
    text: parse.text.trim(),
    knownValues: parse.start.knownValues
  }
  schedule.start = parse.start.date()
  schedule.end = parse.end ? parse.end.date() : null

  return schedule
}

export const getTodaySchedule = () => {
  const today = new Date()
  return {
    start: today,
    parse: {
      text: null,
      knownValues: {
        day: today.getDate(),
        month: today.getMonth(),
        year: today.getFullYear()
      }
    }
  }
}

export const isShitTrashed = () => {
  return 'deletedAt' in this.shit && this.shit.deletedAt !== null
}

export const isShitEmpty = () => {
  return !this.shit.description
}
